const Form009SC = {
    stepName: {
        statement: "重要提示",
        applicationInfo: "申請訊息",
        confirmation: "確認頁",
    },

    errorMsg: {
        cl: "上述選項必填一個",
        atLeastOne: "至少填寫一條地點及日期",
    },
    headTitle: {
        teacher: "隨團教師申請表",
        headerLetter: "校長推薦書（教師適用）",
    },
    colon: "：",
    label: {
        photographs: "正面半身近照",
        chineseName: "獲提名教師中文姓名",
        englishName: "獲提名教師英文姓名",
        idNum: "身份證號碼",
        addressPhone: "住宅電話",
        mobilePhone: "流動電話",

        taughtSchool: "任教學校",
        schoolAddress: "學校地址",
        schoolPhone: "學校電話",
        schoolFax: "學校傳真",
        schoolName: "學校名稱",
        masterName: "校長姓名",
        masterPhone: "學校電話",
        // applicantSign: "申請人簽署",
    },
    label1: {
        header: {
            headerOne: "收集申請者個人資料聲明",
        },
        content: {
            contentOne: "擬提名學生及/或教師參加上述交流團的學校須於",
            contentTwo: "2020年2月24日（星期一）或以前",
            contentThree:
                "把填妥的申請表格，連同所需的文件送交本團辦事處。為免郵遞失誤而洩漏申請人的個人資料，團辦事處鼓勵學校以專人送交或採用掛號郵寄方式遞交申請。如選擇以郵寄方式遞交申請，為免影響郵件派遞，請確保郵資足夠。",
            contentFour: "逾期申請恕不考慮",
            contentFive: "（郵寄申請以郵戳日期為準）。",
        },
        // serialOption: {
        //     a: "(a)",
        //     b: "(b)",
        //     c: "(c)",
        //     d: "(d)",
        //     e: "(e)",
        //     f: "(f)",
        // },
        // useOption: {
        //     a: "辦理與聘用有關的事宜；",
        //     b: "處理發放薪金津貼，以及計算公積金的供款和贈款；",
        //     c: "進行核數工作；",
        //     d: "進行研究及統計資料，以便規劃教育服務；",
        //     e: "處理有關教育專業人員發展的事宜；",
        //     f: "執行《教育條例》、《教育規例》及附屬《補助/津貼學校公積金規則》(第279章)。",
        // },
        // doc: {
        //     d1: "個人資料收集聲明",
        //     d2: "教育局會利用本表格所載的個人資料，作以下其中一種或多種用途︰",
        //     d3: "申請人必須在本表格上填寫個人資料。申請人如不提供這些資料，申請的處理工作及結果或會受影響。",
        //     d4: "本表格所蒐集的個人資料，或會向其他獲授權的政府決策局/部門/機構披露作上述用途。",
        //     d5: "根據《個人資料(私隱)條例》，第18和22條及附表1保障資料第6原則的規定，你有權要求查閱及改正你的個人資料。要求查閱的權利，包括要求提供本表格所載個人資料的副本，但須繳付費用。",
        //     d6: "如欲查詢有關本表格所蒐集的個人資料，包括要求查閱及改正資料事宜，需以書面方式向教育局提出。",
        // },

        statementCon: {
            text1: "隨團教師所提交的個人資料及相關文件（如個人資料表及證件影印本等），將用於處理參加交流團之用。參加者如未能提供所需資料，有關申請將不獲受理。",
            text2: "教育局會按需要，將個人資料送交獲授權處理的航運機構、酒店、旅行社、保險公司或相關單位，以便安排學習、交流、參訪、住宿、交通及緊急醫療等事宜。",
            text3: "所有個人資料及相關文件（包括個人資料表及證件影印本等）將於交流團完結後銷毀。",
            text4: "獲提名參加者有權根據《個人資料（私隱）條例》（香港特別行政區法例第486章）第18和22條，以及附表1第6項原則規定，查閱和更正所提供的個人資料。如對參加交流團所收集的個人資料有任何查詢，包括查閱及更正資料，請聯絡香港灣仔皇后大道東213號胡忠大廈11樓1141室教育局公益少年團辦事處（電話：2892 6660）。",
        },

        statement: "本人已閲讀、明白及同意上述條款及細則",
    },
    label2: {
        sex: "性別",
        sexOption: {
            Male: "男",
            Female: "女",
        },
        canLanguage: "能操語言",
        languageOption: {
            cantonese: "廣東話",
            english: "英語",
            mandarin: "普通話",
            korean: "韓語",
            other: "其他（請註明）",
        },
        languageNewOption: {
            cantonese: "廣東話",
            english: "英語",
            mandarin: "普通話",
            other: "其他（請註明）",
        },
        otherNote1: "請註明",
        languageDocument: "外語證書",
    },
    label3: {
        birthDate: "出生日期",
    },
    publicServiceDate: {
        t1: "本人自",
        t2: "至今於本校擔任公益少年團導師，現時團員人數約",
        t3: "人",
        t4: "正整數",
    },

    interest: "興趣/專長",

    signNote:
        "本人答應一旦獲選為2020年公益少年團傑出團員交流團的隨團教師，將會出席所有出發前的會議、訓練及回港後的匯報日，並全程帶領及指導團員參與各項交流活動及協助團員完成交流成果報告。",
    sign: "申請人簽署",
    signDate: "日期",
    personConfirm: {
        p: "收集申請者個人資料聲明",
        p1: "隨團教師所提交的個人資料及相關文件（如個人資料表及證件影印本等），將用於處理參加交流團之用。參加者如未能提供所需資料，有關申請將不獲受理。",
        p2: "教育局會按需要，將個人資料送交獲授權處理的航運機構、酒店、旅行社、保險公司或相關單位，以便安排學習、交流、參訪、住宿、交通及緊急醫療等事宜。",
        p3: "所有個人資料及相關文件（包括個人資料表及證件影印本等）將於交流團完結後銷毀。",
        p4: "獲提名參加者有權根據《個人資料（私隱）條例》（香港特別行政區法例第 486 章）第 18 和 22 條，以及附表 1 第 6 項原則規定，查閱和更正所提供的個人資料。如對參加交流團所收集的個人資料有任何查詢，包括查閱及更正資料，請聯絡香港灣仔皇后大道東 213 號胡忠大廈 11 樓 1141 室教育局公益少年團辦事處（電話：2892 6660）。",
    },
    applicantInfo: {
        information: "獲提名教師資料",
        name: "獲提名教師姓名",
        chineseName: "獲提名教師姓名（中文）",
        englishName: "獲提名教師姓名（英文）",
        conduct: "獲提名教師的品行",
        perseverance:
            "獲提名教師在負責公益少年團活動方面的表現（例如做事的積極性、責任感、態度等）",
        ability: "獲提名教師的語言能力（1 分最低至 5 分最高）",
        threeLanguageOption: {
            mandarin: "普通話",
            english: "英語",
        },
        threeScoreOption: {
            1: "1",
            2: "2",
            3: "3",
            4: "4",
            5: "5",
        },
        comment: "其他評語/備註",
    },
    teacherApp: {
        activity: "簡述曾負責的公益少年團活動",
        award: "已獲頒授的公益少年團功績榮譽獎勵計劃獎項",
        appreciationForOneYearOfService: "感謝狀（已服務一年）",
        appreciationForTwoYearOfService: "感謝狀（已服務二年）",
        recognitionCertificateTwoToFourYears: "嘉許狀（已服務三至四年）",
        recognitionCertificateSpecialNomination:
            "嘉許狀（只服務一、兩年但獲特殊破格提名）",
        loyalServiceAward: "忠誠服務獎",
        goodServiceAward: "良好服務獎",
        excellentServiceAward: "優異服務獎",
        bronzeMedal: "銅章",
        silverMedal: "銀章",
        overseaExchange:
            "曾否帶領學生進行境外交流活動（如有，請列出最近兩次地點及日期）",
        exchangeOption: {
            yes: "有",
            no: "沒有",
        },
        haveNote: {
            h1: "（1）",
            h2: "（2）",
        },
        site: "地點",
        date: "日期",
        aid: "是否持有有效急救證書",
        aidDate: "有效期至",
        aidDocument: "急救證書",
    },
    teacherLet: {
        position: "獲提名教師職位",
        positionOption: {
            pO1: "副校長",
            pO2: "主任",
            pO3: "教師",
        },
        service: {
            y1: "獲提名教師於本校服務公益少年團年資：",
            y2: "年",
        },
    },
    changeTitle: {
        c1: "{{year}}年公益少年團傑出團員{{country}}交流團",
    },
    promise: {
        p1: "本人謹此確認如本人獲選為{{year}}年公益少年團{{country}}傑出團員交流團的隨團教師，定必出席所有出發前的籌備會議、訓練及交流結束後的小組報告匯報日，並全程帶領及指導團員參與各項交流活動及協助團員完成交流成果的小組報告。",
    },
};
export default Form009SC;
